import { SPECIALS_GRID_LIMIT } from '@iheartjane/menu';
import { Flex, useMobileMediaQuery } from '@iheartjane/reefer';
import { useMemo } from 'react';
import { useLocation } from 'react-router';

import { useSearchContext } from '@jane/search/hooks';
import { JaneGoldCallout } from '@jane/shared-ecomm/components';
import {
  useAuthentication,
  useBrandSpecialsContext,
  useComposeMenuFilters,
  useMenu,
} from '@jane/shared-ecomm/providers';
import { useInfiniteTargetedBrandSpecials } from '@jane/shared/data-access';

import { MenuFiltersAndProductsGrid } from '../../MenuComponents/MenuFiltersAndProductsGrid/MenuFiltersAndProductsGrid';
import { MenuPageSeo } from '../../MenuComponents/MenuSeo/MenuPageSeo';
import { MenuTitle } from '../../MenuComponents/MenuTitle/MenuTitle';
import { MenuBrandSpecialsGrid } from './MenuBrandSpecialsGrid';

export const MenuBrandSpecials = () => {
  const isMobile = useMobileMediaQuery({});
  const location = useLocation();
  const { store, paths } = useMenu();
  const { searchState } = useSearchContext();
  const { brandSpecialFilter } = useBrandSpecialsContext();

  const {
    defaultLogin,
    errors,
    onAppleClick,
    onGoogleClick,
    register,
    resetError,
    resetPassword,
    showAppleLogin,
    showGoogleLogin,
  } = useAuthentication();

  const authentication = {
    errors,
    login: defaultLogin,
    onAppleClick,
    onGoogleClick,
    register,
    resetError,
    resetPassword,
    showAppleLogin,
    showGoogleLogin,
  };

  const {
    data: brandSpecialsPage,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteTargetedBrandSpecials({
    storeIds: [store.id],
    perPage: SPECIALS_GRID_LIMIT,
  });
  const paginatedBrandSpecials = useMemo(
    () =>
      brandSpecialsPage?.pages
        ?.flatMap((page) => page.brand_specials)
        .filter((brandSpecial) => !!brandSpecial) || [],
    [brandSpecialsPage]
  );

  const isFilteringProducts =
    Object.values(searchState).filter(Boolean).length > 0;

  const staticFilters = useComposeMenuFilters([brandSpecialFilter]);

  const nextBreadcrumbs = [
    {
      title: 'Jane Gold',
      url: location.pathname,
    },
  ];

  return (
    <Flex flexDirection="column" gap={isMobile ? 24 : 48}>
      <MenuPageSeo title="Jane Gold" path={paths.menuCategory('jane-gold')} />
      <MenuTitle title="Jane Gold rewards" px={isMobile ? 24 : 64} />
      <JaneGoldCallout
        authentication={authentication}
        storeState={store.state}
        variant="goldRewards"
        mx={isMobile ? 24 : 64}
      />
      {!isFilteringProducts && (
        <MenuBrandSpecialsGrid
          hasNextBrandSpecialsPage={hasNextPage}
          fetchNextBrandSpecialsPage={fetchNextPage}
          loadingBrandSpecialsPage={isFetching}
          paginatedBrandSpecials={paginatedBrandSpecials}
          isFetchingNextBrandSpecialsPage={isFetchingNextPage}
        />
      )}
      <MenuFiltersAndProductsGrid
        breadcrumbs={nextBreadcrumbs}
        menuCategory="jane-gold"
        pageTitle="Jane Gold rewards"
        staticFilters={staticFilters}
      />
    </Flex>
  );
};
